import axios from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

export interface FundList {
  funds: Fund[];
}

export interface Fund {
  id: number;
  type: string;
  isin: string;
  wkn?: string;
  name: string;
  emitter?: string;
  category?: string;
  subCategory?: string;
  fundCurrency?: string;
  riskClass?: number;
  popularity?: 1 | 2 | 3;
  courtages: Courtage[];
}

export interface Courtage {
  bankName: string;
  bic: string;
  agio: number;
  discountOnAgio: number;
  portfolioCommission: number;
  hasSavingsPlan?: boolean;
  savingsPlanMinAmount?: number;
  hasVl?: boolean;
}

const API_URL = 'https://rentablo.de/api/v1';

const searchFunds = async (search: string) => {
  const response = await axios.get<FundList>(
    `${API_URL}/funds`,

    { params: { search, includeCommissions: true, perPage: 10 } }
  );

  return response.data;
};

const getFunds = async (isins: string[]) => {
  const response = await axios.get<FundList>(
    `${API_URL}/funds`,

    { params: { isin: isins, includeCommissions: true } }
  );

  return response.data;
};

export const useSearchFunds = (search?: string) =>
  useQuery(['searchFunds', search], () => searchFunds(search ?? ''), {
    enabled: !!search && search.length >= 3,
  });

export const useGetFunds = (
  isins?: string[],
  options?: UseQueryOptions<FundList, unknown, FundList, any>
) =>
  useQuery(['useGetFunds', isins], () => getFunds(isins ?? []), {
    ...options,
    enabled: !!isins && isins.length > 0,
    staleTime: 60 * 60 * 24,
  });
